export default __webpack_public_path__ + "static/media/WM0480.34I-43543_-26175_0.e22873f1.jpg";